var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Grid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "shape-1",
    stroke: "#030819",
    strokeWidth: 2,
    strokeLinecap: "round",
    x: 4,
    y: 4,
    width: 6,
    height: 6,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "shape-2",
    stroke: "#030819",
    strokeWidth: 2,
    strokeLinecap: "round",
    x: 4,
    y: 14,
    width: 6,
    height: 6,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "shape-3",
    stroke: "#030819",
    strokeWidth: 2,
    strokeLinecap: "round",
    x: 14,
    y: 4,
    width: 6,
    height: 6,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "shape-4",
    stroke: "#030819",
    strokeWidth: 2,
    strokeLinecap: "round",
    x: 14,
    y: 14,
    width: 6,
    height: 6,
    rx: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.891ad416a0b8e895e131d34997741546.svg";
export { ForwardRef as ReactComponent };